fragment OrderItemProductVariationFragment on OrderItemProductVariation {

    id

    order_item_id

    product_variation_id

    productVariation {
        ...ProductVariationFragment
    }

    quantity
    code_of_type

    color_code
    color_name

    size_name
    size_code

    flash_id
    flash_type
    flash_version

    pcs_attachment_cost
    total_attachment_cost

    pcs_imprint_cost
    total_imprint_cost

    pcs_start_cost
    total_start_cost

    pcs_print_handling_charge
    total_print_handling_charge

    pcs_price
    total_price

    orderItemProductVariationAttachments {
        ...OrderItemProductVariationAttachmentFragment
    }

    orderItemProductVariationPrints {
        ...OrderItemProductVariationPrintFragment
    }

    created_at
    updated_at

}